import React, { useState, useEffect } from 'react';
import { 
  Box, 
  Typography, 
  CircularProgress,
  Pagination,
  Alert
} from '@mui/material';
import ListItemOwnerDebtor from './ListItemOwnerDebtor';
import { fetchReport, handleError } from '../../utils/lib';
import { useSnackbar } from '../../providers/SnackBarProvider';
import { useTranslation } from 'react-i18next';

const DebtorsToleranceReport = () => {
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(1);
  const snackbar = useSnackbar();

  // Always fetch fresh data when component mounts
  useEffect(() => {
    fetchDebtorsWithTolerance(page);
  }, []);

  const fetchDebtorsWithTolerance = async (pageNumber) => {
    setIsLoading(true);
    try {
      const response = await fetchReport('DEBTORS_TOLERANCE', pageNumber);
      setData(response);
      setPage(pageNumber);
    } catch (error) {
      handleError(error, snackbar);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePageChange = (event, value) => {
    fetchDebtorsWithTolerance(value);
  };

  const handleAddPayment = () => {
    fetchDebtorsWithTolerance(page);
  }

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" p={3}>
        <CircularProgress />
      </Box>
    );
  }

  if (!data || !data.content || data.content.length === 0) {
    return (
      <Box textAlign="center" p={3}>
        <Typography variant="body1">{t('reports.noDebtorsToleranceData')}</Typography>
      </Box>
    );
  }

  return (
    <Box>
      <Box mb={2} display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h6">
          {t('reports.debtorsTolerance')} ({data.total_results || data.content.length})
        </Typography>
      </Box>

      {data.content && data.content.map((owner) => (
        <ListItemOwnerDebtor
          key={owner.id}
          owner={owner}
          onAddPayment={handleAddPayment}
        />
      ))}

      {data.total_pages && data.total_pages > 1 && (
        <Box display="flex" justifyContent="center" mt={2}>
          <Pagination
            count={data.total_pages}
            page={page}
            onChange={handlePageChange}
            color="primary"
          />
        </Box>
      )}
    </Box>
  );
};

export default DebtorsToleranceReport; 